import { useCallback } from "react";
import { GroupsApi, useAPIAction } from "melco-shared-logic";

export const useDeleteMachineGroups = () => {
  const [deleteMachineGroup] = useAPIAction(
    GroupsApi,
    async (api, id: string) => {
      const data = await api.statisticsGroupsDelete({ id });

      return {
        successMessages: [{ message: "default" }],
        data,
      };
    },
    {
      translationPrefix: "reporting.machinegroups.actions.delete",
    }
  );

  return useCallback(
    async (machineGroupIds: string[]) => {
      const successfullyDeleted: string[] = [];

      for (const machineGroupId of machineGroupIds) {
        try {
          await deleteMachineGroup(machineGroupId);
          successfullyDeleted.push(machineGroupId);
        } catch (e) {
          // error handling is already done in useAPIAction
        }
      }

      return successfullyDeleted;
    },
    [deleteMachineGroup]
  );
};
